import React from 'react'
import { Box } from "@mui/material";
import UpcomingEventsData from './UpcomingEvents';
import MainLayout from '../../components/MainLayout';
import { colors } from '../../Theme/tokens';

export default function Products() {
    React.useEffect(() => {
        window.scrollTo(0,0)
      },[])
    return (
        <MainLayout>
            <Box sx={{ backgroundColor: {xs:"white",sm: colors.background.default}}} height='auto'>
                <Box sx={{
                    backgroundColor: 'white',
                    padding: {
                        sm: '20px 33px 35px 33px',
                        xs: '10px 15px 35px 15px'
                    },
                    borderRadius: '18px',
                    boxShadow: `0px 1px 5px 0px ${colors.border.card}`
                }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Box sx={{ mt: 2 }}>
                            <UpcomingEventsData />
                        </Box>
                    </Box>
                </Box>
            </Box>
        </MainLayout>
    )
}
